import { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
import { userLoginKey } from "../config";
import Logo from "../assets/img/logo60.png";
import GlobalState from "../context/MenuSelect";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Menu = () => {

  const [userLogin, setUserLogin] = useState(false);
  const { loginContext } = useContext(GlobalState);

  useEffect(() => {
    if (sessionStorage.getItem(userLoginKey)) {
      setUserLogin(true);
    } else {
      setUserLogin(false);
    }
  }, [loginContext]);

  const scrollHandle = (e) => {
    e.preventDefault();

    const id = e.currentTarget.id;
    const targetId = id.slice(0, id.length - 1);

    window.location.href = "/#" + targetId;

    const position = document.getElementById(targetId);

    if (position) {
      position.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  return (
    <Container id="header">

      <Row>

        <Col xl={6} lg={3}>

          {/* 跳到主要內容 */}
          <div className="container">
            <a
              className="sr-only text-nowrap"
              href="#aC"
            >
              跳到主要內容區
            </a>
          </div>

          {/* Logo */}
          <div className="container d-flex align-items-center justify-content-between">

            <h1 className="logo">
              <a href="/">
                <img
                  src={Logo}
                  alt=""
                  className="logo-mobile"
                />

                <span className="title-mobile text-nowrap">
                  &nbsp;
                  <strong>e</strong>
                  化金檢知識網
                </span>
              </a>
            </h1>

          </div>

        </Col>

        <Col className="d-flex align-items-center justify-content-end">

          <nav
            id="navbar"
            className="navbar"
            aria-label="主要選單"
          >
            <ul>

              {/* U：上方選單連結區 */}
              <li>
                <a
                  className="accesskey"
                  href="#aU"
                  id="aU"
                  accessKey="U"
                  title="上方選單連結區，此區塊列有本網站的主要選單"
                >
                  :::
                </a>
              </li>

              <li>
                <a
                  className="nav-link scrollto"
                  onClick={scrollHandle}
                  id="about-"
                  href=""
                >
                  回首頁
                </a>
              </li>

              {userLogin ? (
                <li>
                  <a
                    className="nav-link scrollto"
                    href="/classFirst"
                  >
                    課程列表
                  </a>
                </li>
              ) : null}

              <li>
                <a
                  className="nav-link scrollto"
                  href="/sitemap"
                >
                  網站導覽
                </a>
              </li>

              <li>
                <a
                  className="nav-link scrollto"
                  href="/sectionSuggestion"
                >
                  意見區
                </a>
              </li>

              {!userLogin ? (
                <li>
                  <a
                    className="getstarted scrollto"
                    onClick={scrollHandle}
                    id="services-"
                    href=""
                  >
                    進入課程
                  </a>
                </li>
              ) : null}

            </ul>
          </nav>

        </Col>

      </Row>

    </Container>
  );
};

export default Menu;
